// Shim for react-native-dotenv @env module in web builds
// This module re-exports environment variables from process.env

export const REACT_APP_ENV = process.env.REACT_APP_ENV;
export const REACT_APP_REGION = process.env.REACT_APP_REGION;
export const REACT_APP_aws_user_pools_id = process.env.REACT_APP_aws_user_pools_id;
export const REACT_APP_aws_user_pools_web_client_id = process.env.REACT_APP_aws_user_pools_web_client_id;
export const REACT_APP_aws_cognito_identity_pool_id = process.env.REACT_APP_aws_cognito_identity_pool_id;
export const REACT_APP_aws_cognito_domain = process.env.REACT_APP_aws_cognito_domain;
export const REACT_APP_redirect_signin_uri = process.env.REACT_APP_redirect_signin_uri;
export const REACT_APP_redirect_signout_uri = process.env.REACT_APP_redirect_signout_uri;
export const REACT_APP_aws_region = process.env.REACT_APP_aws_region;
export const REACT_APP_aws_appsync_region = process.env.REACT_APP_aws_appsync_region;
export const REACT_APP_GRAPHQL_ENDPOINT = process.env.REACT_APP_GRAPHQL_ENDPOINT;
export const REACT_APP_WORKSPACE_COLLAB = process.env.REACT_APP_WORKSPACE_COLLAB;
export const REACT_APP_STRIPE_PK = process.env.REACT_APP_STRIPE_PK;
export const REACT_APP_RTC_API = process.env.REACT_APP_RTC_API;
export const REACT_APP_REST_ENDPOINT = process.env.REACT_APP_REST_ENDPOINT;
export const REACT_APP_SUPPORT_TOKEN = process.env.REACT_APP_SUPPORT_TOKEN;
export const REACT_APP_AI_REST_ENDPOINT = process.env.REACT_APP_AI_REST_ENDPOINT;
export const REACT_APP_AIS_ENDPOINT = process.env.REACT_APP_AIS_ENDPOINT;
export const REACT_APP_WEBSITE_TOKEN = process.env.REACT_APP_WEBSITE_TOKEN;
export const REACT_APP_WEBSITE_WORKSPACE = process.env.REACT_APP_WEBSITE_WORKSPACE;
export const REACT_APP_WEBSITE_AGENT = process.env.REACT_APP_WEBSITE_AGENT;
export const REACT_APP_GRAPHQL_TOKEN = process.env.REACT_APP_GRAPHQL_TOKEN;
export const REACT_APP_CONTENTFUL_TOKEN = process.env.REACT_APP_CONTENTFUL_TOKEN;
export const REACT_APP_CONTENTFUL_SPACE = process.env.REACT_APP_CONTENTFUL_SPACE;
export const REACT_APP_CLOUD_FRONT_DISTRIBUTION = process.env.REACT_APP_CLOUD_FRONT_DISTRIBUTION;
export const REACT_APP_ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY;
